// extracted by mini-css-extract-plugin
export default {"ringHolder":"IncomingCall_ringHolder__vxKsL","isGroup":"IncomingCall_isGroup__qKvio","ring":"IncomingCall_ring__dkWzZ","ringing":"IncomingCall_ringing__7Cz1M"};